import Layout from "../Layout";
import Footer from "../../components/Footer";
import CertificateTabs from "../../components/CertificateTabs";
import GeneralHeader from "../../components/GeneralHeader";

const CertificatePage = () => {
  return (
    <Layout
      header={<GeneralHeader />}
      center={<CertificateTabs />}
      footer={<Footer />}
    />
  )
}

export default CertificatePage;